import { ComponentIdSpan } from '@inter-ikea-core/core'

const base = ComponentIdSpan.SOFA_BASE_ID

export const SOFA_CORE_ID = {
  MEASUREMENT_VISIBLE_COMPONENT: base + 1,
} as const
